<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <signup-card>
        <h2 class="title text-center" slot="title">Register</h2>
        <div
          class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 ml-auto"
          slot="content-left"
        >
          <div
            class="info info-horizontal"
            v-for="item in contentLeft"
            :key="item.title"
          >
            <div :class="`icon ${item.colorIcon}`">
              <md-icon>{{ item.icon }}</md-icon>
            </div>
            <div class="description">
              <h4 class="info-title">{{ item.title }}</h4>
              <p class="description">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 mr-auto"
          slot="content-right"
        >
          <div class="social-line text-center">
            <md-button class="md-just-icon md-round md-twitter">
              <i class="fab fa-twitter"></i>
            </md-button>
            <md-button class="md-just-icon md-round md-dribbble">
              <i class="fab fa-dribbble"></i>
            </md-button>
            <md-button class="md-just-icon md-round md-facebook">
              <i class="fab fa-facebook-f"></i>
            </md-button>
            <h4 class="mt-3">or be classical</h4>
          </div>

          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(submit)">
              <ValidationProvider rules="required" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>face</md-icon>
                  <label>Full name</label>
                  <md-input v-model="name" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>email</md-icon>
                  <label>Email Adress</label>
                  <md-input v-model="email" type="email"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                name="password"
                rules="required|confirmed:confirmation"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>lock_outline</md-icon>
                  <label>Password</label>
                  <md-input v-model="password" type="password"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>

              <ValidationProvider
                vid="confirmation"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>lock_outline</md-icon>
                  <label>Confirm Password</label>
                  <md-input v-model="confirmation" type="password"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
              <md-checkbox v-model="boolean"
                >I agree to the <a>terms and conditions</a>.</md-checkbox
              >
              <div class="button-container">
                <md-button
                  type="submit"
                  class="md-accent md-round mt-4"
                  slot="footer"
                  >Get Started</md-button
                >
              </div>
            </form>
          </ValidationObserver>
        </div>
      </signup-card>
    </div>
  </div>
</template>
<script>
import { SignupCard } from "@/components";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import { SlideYDownTransition } from "vue2-transitions";
import { logIn, register } from "@/api/auth.service";

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  components: {
    SignupCard,
    SlideYDownTransition
  },
  data() {
    return {
      boolean: false,
      name: null,
      email: null,
      password: null,
      confirmation: null,
      contentLeft: [
        {
          colorIcon: "icon-info",
          icon: "engineering",
          title: "Under construction",
          description:
            "You can create an account to request access, but we are still under development" +
            "and don't offer any services yet. You wish to contact us? Email us at " +
            "j.peshev@homegaroo.nl or m.garkov@homegaroo.nl"
        },

        {
          colorIcon: "icon-success",
          icon: "group",
          title: "Fast",
          description: "Text 1"
        },

        {
          colorIcon: "icon-danger",
          icon: "code",
          title: "Convenient",
          description: "Text 2."
        },

        {
          colorIcon: "icon-info",
          icon: "security",
          title: "Reliable",
          description: "Text 3."
        }
      ]
    };
  },
  methods: {
    submit() {
      if (!this.boolean) {
        this.$toasted.error(
          "To continue, you need to accept our terms and conditions!",
          {
            position: "top-center"
          }
        );
      } else {
        register(this.name, this.name, this.email, this.password)
          .then(_ => {
            this.$router.push({ name: "AccountCreated" });
          })
          .catch(() => {
            this.$toasted.error(
              "Something went wrong and we were unable to register you!",
              {
                position: "top-center"
              }
            );
          });
      }
    }
  },
  mounted() {
    this.$notify({
      message:
        "We are still under development, therefore all newly created accounts need admin approval before they can access the website at its current stage.",
      icon: "add_alert",
      type: "info",
      horizontalAlign: "center",
      verticalAlign: "top"
    });
  }
};
</script>
<style></style>
